var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZ4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.019 90.148",
    width: 119.019,
    height: 90.148,
    enableBackground: "new 0 0 119.019 90.148",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M93.195,38.416H0V0h119.019v12.592C119.019,26.854,107.457,38.416,93.195,38.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.824,51.733h90.004v38.416H0l0-12.592C0,63.294,11.562,51.733,25.824,51.733z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "98.659,37.835 39.137,51.733 21.459,52.101 83.737,38.416  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ4);
export default __webpack_public_path__ + "static/media/z4.4f6fca25f24ed707ac976dc04c65e002.svg";
export { ForwardRef as ReactComponent };